'use client';
import React, { useRef, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import {
  Box,
  SimpleGrid,
  Text,
  Image,
  Button,
  Center,
  background,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux'; // Import Redux's dispatch function
import { setStateValue } from '@/app/redux/slices/configGymSlice';
import costsData from '/public/data/costs.json';

const outerSelector = {
  bgColor: 'white',
  borderRadius: { base: '4vw', sm: '2vw' },
  padding: { base: '6vw 2vw 2vw', md: '3vw 2vw 2vw' },
  textAlign: 'center',
  gridTemplateRows: {
    base: 'auto 1.4fr 1.8fr 1.4fr 1.4fr',
    md: 'auto 1.5fr 2.4fr 2.4fr 1.8fr',
  },
  position: 'relative',
  marginTop: { base: '0vw', md: '3vw' },
};
const showImgBox = {
  padding: '0 0 0 0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'start',
  width: '100%',
};
const showImg = {
  width: '80%',
  height: 'auto',
  objectFit: 'contain',
};
const selectedButton = {
  background: 'white',
  position: 'absolute',
  top: '-6',
  zIndex: '10',
  border: 'solid 2px #0cc6de',
  color: '#0cc6de',
  borderRadius: { base: '6vw', md: '3vw' },
  padding: { base: '1.2vw 3vw', md: '1.3vw 3vw', lg: '1.5vw 3vw' },
  fontSize: { base: '3vw', md: '1.4vw', lg: '1.2vw' },
};
const showTitle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: { base: '6vw', md: '2.2vw' },
  fontWeight: 700,
};
const showDesc = {
  fontSize: { base: '3vw', md: '1vw' },
  lineHeight: { base: '3.5vw', md: '1.2vw' },
  letterSpacing: '-0.02vw',
  padding: { base: '0 1.5vw', md: '0' },
};
const showPrice = {
  //   border: 'solid 3px blue',
};
const priceGrid = {
  display: 'inline-grid',
  gridTemplateColumns: 'auto auto auto',
  gridTemplateRows: 'auto auto',
  width: 'auto',
  margin: '0 auto',
  fontWeight: 600,
};
const priceText = {
  gridColumn: '1 / 4',
  gridRow: '1',
  fontSize: { base: '2.4vw', md: '1.2vw' },
  textAlign: 'start',
  alignSelf: 'end',
  //   /border: 'solid 3px red',
  lineHeight: { base: '3vw', md: '1.5vw' },
};
const pricePound = {
  fontSize: { base: '5vw', md: '2.5vw' },
  //   border: 'solid 3px red',
  fontWeight: 600,
  alignSelf: 'start',
  padding: { base: '0 1vw 0 0', md: '0 0.5vw 0 0' },
  lineHeight: { base: '5vw', md: '3vw' },
};
const pricePounds = {
  gridColumn: '2 / 3',
  gridRow: '2',
  fontSize: '4vw',
  lineHeight: { base: '8vw', md: '4vw' },
  fontWeight: 700,
  fontSize: { base: '8vw', md: '4vw' },
};
const pricePence = {
  gridColumn: '3 / 4',
  gridRow: '2',
  alignSelf: 'end',
  fontSize: { base: '3.6vw', md: '1.8vw' },
  lineHeight: { base: '4vw', md: '2vw' },
};
const buttonSelect = {
  width: '100%',
  borderRadius: { base: '6vw', md: '2.5vw' },
  bgColor: '#0cc6de',
  color: 'white',
  alignSelf: 'end',
  fontSize: { base: '4.4vw', md: '1.2vw', lg: '1.2vw' },
  fontWeight: 600,
  padding: { base: '3vw 0', md: '1.5vw 0' },
  _hover: {
    cursor: 'pointer', // Correct hover effect for the button
    bgColor: '#0cc6de80',
  },
};
const buttonSelectGry = {
  width: '100%',
  borderRadius: { base: '6vw', md: '2.5vw' },
  bg: 'gray.700',
  color: 'white',
  alignSelf: 'end',
  fontSize: { base: '4.4vw', md: '1.2vw', lg: '1.2vw' },
  fontWeight: 600,
  padding: { base: '3vw 0', md: '1.5vw 0' },
  _hover: {
    cursor: 'pointer', // Correct hover effect for the button
    bg: 'gray.500',
  },
};
const heading = {
  fontSize: { base: '6vw', md: '2vw' },
  fontWeight: 700,
  color: 'white',
};
const headText = {
  fontSize: { base: '4vw', md: '1vw' },
  textAlign: 'center',
  color: 'white',
  padding: { base: '0 0 10vw', md: '0' },
};

function StartSelector() {
  const router = useRouter();
  const services = useSelector((state) => state.gym.survey);
  const gitRef = useRef(null); // To get the reference to the hero container
  const progress = useSelector((state) => state.gym.progressOpt);
  const salePrice = costsData.find((item) => item.name === 'sale');
  const dispatch = useDispatch(); // Initialize dispatch from Redux

  const Bpounds = Math.floor(salePrice.L); // Extracts the pound part
  const Bpence = (salePrice.L % 1).toFixed(2).substring(2); // Extracts the pence part

  const Spounds = Math.floor(salePrice.standard); // Extracts the pound part
  const Spence = (salePrice.standard % 1).toFixed(2).substring(2); // Extracts the pence part

  const Ppounds = Math.floor(salePrice.premium); // Extracts the pound part
  const Ppence = (salePrice.premium % 1).toFixed(2).substring(2); // Extracts the pence part

  const SVpounds = Math.floor(salePrice.survey); // Extracts the pound part
  const SVpence = (salePrice.survey % 1).toFixed(2).substring(2); // Extracts the pence part

  const handleSelect = (selected) => {
    dispatch(setStateValue({ key: 'serviceOpt', value: selected })); // Dispatch the selected package to Redux
    // Scroll the page up to the git form

    if (typeof window !== 'undefined') {
      const GITSection = document.getElementById('GITform');
      if (GITSection && selected === 'premium') {
        GITSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (selected == 'basic' || selected == 'standard') {
      dispatch(setStateValue({ key: 'progressOpt', value: 'Mirrors' }));
      router.push('/mirrors');
    }
    if (selected == 'survey') {
      const updatedChoices = services.map((choice) => ({
        ...choice,
        selected: choice.type === 'paid',
        complete: choice.type === 'paid',
      }));
      dispatch(setStateValue({ key: 'survey', value: updatedChoices }));
      dispatch(setStateValue({ key: 'progressOpt', value: 'Survey' }));
      dispatch(setStateValue({ key: 'install', value: 'no' }));
      router.push('/survey');
    }
  };

  // Use useEffect to trigger the scroll when 'progressOpt' is set to 'Service'
  // useEffect(() => {
  //   if (progress === 'Service') {
  //     const Packages = document.getElementById('packages');
  //     if (Packages) {
  //       Packages.scrollIntoView({ behavior: 'smooth' });
  //     }
  //   }
  // }, [progress]); // Run this effect whenever the 'progress' changes

  return (
    <Box
      ref={gitRef}
      width="100%"
      border="0"
      p={{ base: '5vw 5vw 5vw', md: '2svw 10vw' }}
      bgColor={'#2e2925'}
      id="packages"
    >
      <Center {...heading}>Our Packages?</Center>
      <Center {...headText}>
        We offer a nationwide services to ensure a seamless experience for our
        clients.
      </Center>

      <SimpleGrid
        columns={{ base: 2, md: 4 }}
        spacing={{ base: '2vw', md: '1vw' }}
      >
        <SimpleGrid {...outerSelector}>
          <Box {...showImgBox}>
            <Image
              {...showImg}
              src="images/gym/basic-icon.jpg"
              alt="Mirrorworld Basic Gym Mirror service"
            />
          </Box>
          <Text {...showTitle}>Basic</Text>
          <Text {...showDesc}>Mirror Only</Text>
          <Box {...showPrice}>
            <Box {...priceGrid} alignItems="center">
              <Text {...priceText}>Starting</Text>
              <Text {...pricePound}>£</Text>
              <Text {...pricePounds}>{Bpounds}</Text>
              <Text {...pricePence}>.{Bpence}</Text>
            </Box>
          </Box>
          <Button {...buttonSelect} onClick={() => handleSelect('basic')}>
            Select
          </Button>
        </SimpleGrid>
        <SimpleGrid {...outerSelector}>
          <Box {...showImgBox}>
            <Image
              {...showImg}
              src="/images/gym/standard-icon.jpg"
              alt="Mirrorworld Standard Gym Mirror service"
            />
          </Box>
          <Text {...showTitle}>Standard</Text>
          <Box>
            <Text {...showDesc} lineHeight={{ base: '5vw', md: '1.5vw' }}>
              White Glove Delivery
            </Text>
            <Text {...showDesc} lineHeight={{ base: '5vw', md: '1.5vw' }}>
              Premium Safety Backing
            </Text>
            <Text {...showDesc} lineHeight={{ base: '5vw', md: '1.5vw' }}>
              Home Installation
            </Text>
          </Box>
          <Box {...showPrice}>
            <Box {...priceGrid} alignItems="center">
              <Text {...priceText}>Starting</Text>
              <Text {...pricePound}>£</Text>
              <Text {...pricePounds}>{Spounds}</Text>
              <Text {...pricePence}>.{Spence}</Text>
            </Box>
          </Box>
          <Button {...buttonSelect} onClick={() => handleSelect('standard')}>
            Select
          </Button>
          <Center>
            <Button {...selectedButton}>Recommended</Button>
          </Center>
        </SimpleGrid>
        <SimpleGrid {...outerSelector}>
          <Box {...showImgBox}>
            <Image
              {...showImg}
              src="images/gym/premium-icon.jpg"
              alt="Mirrorworld Platinum Gym Mirror service"
            />
          </Box>
          <Text {...showTitle}>Premium</Text>
          <Text {...showDesc}>
            Have us create and install a bespoke mirror to match existing décor,
            or something distinct and unique.
          </Text>
          <Box {...showPrice}>
            <Box {...priceGrid} alignItems="center">
              <Text {...priceText}>Starting</Text>
              <Text {...pricePound}>£</Text>
              <Text {...pricePounds}>{Ppounds}</Text>
              <Text {...pricePence}>.{Ppence}</Text>
            </Box>
          </Box>
          <Button {...buttonSelectGry} onClick={() => handleSelect('premium')}>
            Contact Us
          </Button>
        </SimpleGrid>
        <SimpleGrid {...outerSelector}>
          <Box {...showImgBox}>
            <Image
              {...showImg}
              src="images/gym/survey-icon.jpg"
              alt="Mirrorworld Survey Gym Mirror service"
            />
          </Box>
          <Text {...showTitle}>Survey</Text>
          <Text {...showDesc}>
            Enjoy a hassle-free experience as we carry out a structural
            assessment and ensure precise measurements.
          </Text>
          <Box {...showPrice}>
            <Box {...priceGrid} alignItems="center">
              <Text {...priceText}>Starting</Text>
              <Text {...pricePound}>£</Text>
              <Text {...pricePounds}>{SVpounds}</Text>
              <Text {...pricePence}>.{SVpence}</Text>
            </Box>
          </Box>
          <Button {...buttonSelect} onClick={() => handleSelect('survey')}>
            Select
          </Button>
        </SimpleGrid>
      </SimpleGrid>
    </Box>
  );
}

export default StartSelector;
